"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Snippet = void 0;
var react_1 = __importStar(require("react"));
var copy = function (text) {
    void navigator.clipboard.writeText(text);
};
var Snippet = function (_a) {
    var code = _a.children;
    var handleCopy = (0, react_1.useCallback)(function () { return copy(code); }, []);
    return (react_1.default.createElement("div", { className: "bg-light2 d-f dark4 my3 p4 rnd ws-pl" },
        react_1.default.createElement("div", { className: "f3 grow" }, code.split("\n").map(function (line) {
            var spaces = line.length - line.trimStart().length;
            return (react_1.default.createElement("p", { key: line, style: { paddingLeft: "".concat(spaces / 2, "em") } }, line));
        })),
        react_1.default.createElement("button", { className: "as-start bdr-no bg-no hov-bg-light3 ml5 px3 py2 rnd trn2", onClick: handleCopy }, "Copy")));
};
exports.Snippet = Snippet;
